import router from '@/vue-router';

router.addRoute({ 
  component: () => import ('@/views/DepositCardCallback'),
  name: 'deposit-card-callback',
  path: '/deposit/card/:id/:succeeded',
  meta: { template: 4 },
});
